<template>
  <div class="customer-view" v-if="customer">
    <h3 class="customer-name" v-text="customer.name"></h3>
    <div class="customer-email" v-text="customer.email"></div>

    
    <div class="addresses" v-if="!customer.userMustNotEditAddresses">
      <div class="address-summary" v-if="customer.billingAddress && customer.billingAddress.name">
        <div class="address-label" v-text="$t('customer-view-billing-address-label')"></div>
        <div class="address-line name" v-text="customer.billingAddress.name"></div>
        <div class="address-line" v-if="customer.billingAddress.street" v-text="customer.billingAddress.street"></div>
        <div class="address-line">
          <span v-if="customer.billingAddress.zip" v-text="customer.billingAddress.zip + ' '"></span>
          <span v-if="customer.billingAddress.city" v-text="customer.billingAddress.city"></span>
        </div>
      </div>

      <div class="address-summary" v-if="customer.deliveryUsesDifferentAddress && customer.deliveryAddress && customer.deliveryAddress.name">
        <div class="address-label" v-text="$t('customer-view-delivery-address-label')"></div>
        <div class="address-line name" v-text="customer.deliveryAddress.name"></div>
        <div class="address-line" v-if="customer.deliveryAddress.street" v-text="customer.deliveryAddress.street"></div>
        <div class="address-line">
          <span v-if="customer.deliveryAddress.zip" v-text="customer.deliveryAddress.zip + ' '"></span>
          <span v-if="customer.deliveryAddress.city" v-text="customer.deliveryAddress.city"></span>
        </div>
      </div>

      <oido-button class="edit-addresses-button" @click="editAddresses"
        :label="$t(customer.billingAddress ? 'customer-view-edit-addresses-label' : 'customer-view-add-addresses-label')"
        icon="location"></oido-button>
    </div>

    <div class="orders">
      <oido-button class="my-orders-button" @click="showOrders"
      :label="$t('customer-view-my-orders-label')" icon="clipboard"></oido-button>
    </div>
    
    
    <div class="logout">
    <oido-button class="logout-button" @click="logout" :label="$t('customer-view-logout-label')"
      icon="person-circle"></oido-button>
      </div>
  </div>


  <div class="no-customer-view" v-if="!customer">
    <SendLoginCodeButton></SendLoginCodeButton>
  </div>

</template>

<script setup>
import customerService from '../composables/customerService'
import OidoButton from '../components/OidoButton.vue'
import SendLoginCodeButton from './SendLoginCodeButton.vue'
import CustomerAddressesModal from './CustomerAddressesModal.vue'
import CustomerOrdersModal from './CustomerOrdersModal.vue'
import { modalController } from '@ionic/vue'
</script>

<script>
export default {
  props: ["close"],
  data() {
    return {

    }
  },
  watch: {

  },
  computed: {


  },
  async mounted() {
  },
  methods: {
    logout() {

      if (this.close) {
        this.close()
      }
      setTimeout(() => {
        customerService.logout()
      }, 150)
    },
    async editAddresses() {
      if (this.close) {
        this.close()
      }
      const modal = await modalController.create({
        component: CustomerAddressesModal,
        canDismiss: () => true,
        componentProps: {},
      });
      await modal.present();
      await modal.onDidDismiss();
    },
    async showOrders() {
      if (this.close) {
        this.close()
      }
      const modal = await modalController.create({
        component: CustomerOrdersModal,
        canDismiss: () => true,
        componentProps: {},
      });
      await modal.present();
      await modal.onDidDismiss();
    }

  },
}
</script>
<style scoped>

.customer-view{
  cursor: default;
}

.customer-name {
  font-size: 1.1rem;
  /* font-weight: bold; */
  margin: 0;
  padding-bottom: 0.3rem;
}

.customer-email {
  font-size: 0.8rem;
  font-weight: bold;
  margin: 0;
  padding-bottom: 0.3rem;
}

.customer-id {
  font-size: 0.6rem;
  margin: 0;
  padding-bottom: 0.3rem;
}

.logout {
  margin-top: 0.8rem;
  padding-top: 0.6rem;
  border-top: 1px solid #eee;
}
.addresses {
  margin-top: 0.8rem;
  padding-top: 0.6rem;
  border-top: 1px solid #eee;
}

.address-summary {
  margin-bottom: 0.6rem;
  font-size: 0.8rem;
  line-height: 1.3;
}

.address-summary .address-label {
  font-size: 0.65rem;
  text-transform: uppercase;
  color: #888;
  margin-bottom: 0.15rem;
}

.address-summary .address-line.name {
  font-weight: 600;
}

.edit-addresses-button {
  padding: 0.4rem 1rem;
  margin-top: 0.3rem;
}

.orders {
  margin-top: 0.8rem;
  padding-top: 0.6rem;
  border-top: 1px solid #eee;
}

.my-orders-button {
  padding: 0.4rem 1rem;
}

.logout-button{
  padding: 0.4rem 1rem;
}

</style>
